module.exports = __webpack_public_path__ + "static/media/smriti_1.90f2d304.jpg";